export default function RadialGauge({ value = 0, size = 180, stroke = 12, label = "READINESS" }) {
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, value));
  const offset = circ - (pct / 100) * circ;
  const color = pct >= 70 ? "#22C55E" : pct >= 40 ? "#6366F1" : "#F59E0B";
  return (
    <div className="relative inline-flex items-center justify-center" data-testid="radial-gauge">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E2E8F0" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1s ease" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-mono text-4xl font-bold" style={{ color }}>{pct}%</span>
        <span className="eyebrow text-slate-400 mt-1">{label}</span>
      </div>
    </div>
  );
}
